import React from "react";
import { ModalWithIcon } from "@scripts/react/components/RfModal/ModalWithIcon";

interface RelabelConfirmationModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    onCancel: () => void;
    submitButtonText?: string;
    cancelButtonText?: string;
}

export const RelabelConfirmationModal: React.FC<RelabelConfirmationModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    onCancel,
    submitButtonText = "No, stay here",
    cancelButtonText = "Yes, return to labeling"
}) => {
    return (
        <ModalWithIcon
            isOpen={isOpen}
            onClose={onClose}
            onSubmit={onConfirm}
            onCancel={onCancel}
            type="info"
            size="md"
            icon="far fa-exclamation-triangle"
            title="Are you sure you want to relabel your data?"
            submitButtonText={submitButtonText}
            cancelButtonText={cancelButtonText}
            submitButtonProps={{ type: "secondary" }}
        >
            <p className="text-center">
                It's usually better to deploy your model and improve it with new data.
            </p>
            <p className="text-center">
                You can also use the slider to adjust the sensitivity. But if there's a clear
                mistake, feel free to fix it.
            </p>
        </ModalWithIcon>
    );
};
